<template>
    <div class="standard-settings-panel">
        <TabContainer :tabs="tabs" :activeTab.sync="activeTab">
            <template #actions="{ activeTab: currentTab }">
                <div v-if="currentTab === 'facility'" class="tab-controls">
                    <CarbonInput
                        :value="facilitySearchKeyword"
                        @input="facilitySearchKeyword = $event"
                        variant="search"
                        placeholder="시설코드/시설명 검색"
                    />
                    <CarbonSelect
                        :value="facilityFilterOrg"
                        @input="facilityFilterOrg = $event"
                        :options="organizationOptions"
                        placeholder="전체 조직"
                        :placeholderDisabled="false"
                    />
                    <CarbonSelect
                        :value="facilityFilterStatus"
                        @change="onFacilityFilterChange"
                        :options="statusOptions"
                        placeholder="전체 상태"
                        :placeholderDisabled="false"
                    />
                    <CarbonButton
                        icon-only
                        icon="fas fa-plus"
                        title="시설 추가"
                        @click="$refs.facilityTab.openFacilityModal('create')"
                    />
                </div>
                <div v-else-if="currentTab === 'category'" class="tab-controls">
                    <CarbonButton
                        v-if="canManageCategories"
                        icon-only
                        icon="fas fa-plus"
                        title="카테고리 추가"
                        @click="$refs.categoryTab.openCategoryModal('create')"
                    />
                </div>
            </template>
            <template #default="{ activeTab: currentTab }">
                <FacilitySettingsTab
                    v-if="currentTab === 'facility'"
                    ref="facilityTab"
                    :search-keyword="facilitySearchKeyword"
                    :filter-status="facilityFilterStatus"
                    :filter-org="facilityFilterOrg"
                    :organizations="organizations"
                />
                <CategorySettingsTab v-if="currentTab === 'category'" ref="categoryTab" :loginUser="loginUser" />
            </template>
        </TabContainer>
    </div>
</template>

<script>
import TabContainer from "../../common/TabContainer.vue";
import FacilitySettingsTab from "../views/FacilitySettingsTab.vue";
import CategorySettingsTab from "../views/CategorySettingsTab.vue";
import CarbonButton from "../../common/CarbonButton.vue";
import CarbonInput from "../../common/CarbonInput.vue";
import CarbonSelect from "../../common/CarbonSelect.vue";
import CarbonCodes from "../../../codes";
import carbonApi from "../../../api";

export default {
    name: "StandardSettingsPanel",
    components: {
        TabContainer,
        FacilitySettingsTab,
        CategorySettingsTab,
        CarbonButton,
        CarbonInput,
        CarbonSelect,
    },
    props: {
        loginUser: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            activeTab: "facility",
            tabs: [
                { label: "시설 관리", value: "facility" },
                { label: "카테고리 관리", value: "category" },
            ],
            facilitySearchKeyword: "",
            facilityFilterOrg: null,
            facilityFilterStatus: "",
            organizations: [],
        };
    },
    computed: {
        statusOptions() {
            return CarbonCodes.status.getList();
        },
        organizationOptions() {
            return this.organizations.map((org) => ({
                value: org.orgIdx,
                text: org.orgName
                    ? `${org.orgName} (${org.orgCode || org.orgIdx})`
                    : org.orgCode || `조직 #${org.orgIdx}`,
            }));
        },
        canManageCategories() {
            const masterDataPerms =
                this.loginUser?.carbonPermissions?.masterData || this.loginUser?.masterDataPermissions;
            if (!masterDataPerms) return true;
            let actions = [];
            if (Array.isArray(masterDataPerms)) actions = masterDataPerms;
            else if (Array.isArray(masterDataPerms.actions)) actions = masterDataPerms.actions;
            else if (typeof masterDataPerms === "object")
                actions = Object.keys(masterDataPerms).filter((k) => masterDataPerms[k]);
            return actions.map((a) => String(a).toLowerCase()).some((a) => ["write", "delete", "admin"].includes(a));
        },
    },
    mounted() {
        this.loadOrganizations();
    },
    methods: {
        async loadOrganizations() {
            try {
                const res = await carbonApi.organization.getOrgs(1, 500);
                const data = res.data?.data != null ? res.data.data : res.data;
                this.organizations = (data && data.organizations) || [];
            } catch (err) {
                console.error("[StandardSettingsPanel] 조직 목록 조회 실패:", err);
                this.organizations = [];
            }
        },
        onFacilityFilterChange(val) {
            this.facilityFilterStatus = val;
            if (this.$refs.facilityTab) this.$refs.facilityTab.loadFacilities(val);
        },
    },
};
</script>

<style scoped>
.standard-settings-panel {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    padding: 0px 16px;
}

.standard-settings-panel >>> .tab-content {
    flex: 1;
    min-height: 0;
}

.tab-controls {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}
</style>
